import { Logger } from "../../02_utils/logger";
import { Utils } from "../../02_utils/utils";

export class Panel {
  private panelButtons: NodeListOf<HTMLElement>;
  private panelCloseButtons: NodeListOf<HTMLElement>;

  constructor(private $log: Logger, private $utils: Utils) {
    this.panelButtons = document.querySelectorAll('.js-open-panel');
    this.panelCloseButtons = document.querySelectorAll('.js-close-panel');


    this.initPanels();
    this.initClosePanel();
  }

  public initPanels() {
    this.panelButtons?.forEach(button => {
      const openGetter = button.dataset.open;
      const panel = document.querySelector(openGetter) as HTMLElement;

      button.addEventListener('click', () => {
        this.$utils.addOrRemoveClases('add', 'panel-open', document.body);
        this.$utils.addOrRemoveClases('add', 'open', panel);
        this.$utils.activateFlyoutPanelBackdrop();
        panel?.setAttribute('aria-modal', 'true');
        panel?.setAttribute('aria-hidden', 'false');
        panel?.focus();
      }, {passive: true});
    });
  }

  public initClosePanel() {
    this.panelCloseButtons?.forEach(closeButton => {
      closeButton.addEventListener('click', () => {
        this.$utils.addOrRemoveClases('remove', 'panel-open', document.body);
        this.$utils.deactivateFlyoutPanelBackdrop();
      }, {passive: true});
    });

    document.addEventListener("closePanel", () => {
      this.$utils.addOrRemoveClases('remove', 'panel-open', document.body);
      this.$utils.deactivateFlyoutPanelBackdrop();
    })
  }
}
